<template>
  <vs-popup
    class="holamundo"
    :title="title"
    :active.sync="addNewFleetLocal"
    @vs-close="closeForm">
    <form @submit.prevent>
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex flex-col"
        style="width: 600px">
        <label class="vs-input--label">Name<sup>*</sup></label>
        <div class="vs-con-input">
          <input
            type="text"
            v-model="name"
            name="name"
            class="vs-inputx vs-input--input normal"
            style="border: 1px solid rgba(0, 0, 0, 0.2)" />
        </div>
        <span></span>
      </div>
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Code (Shortname)<sup>*</sup></label>
        <div class="vs-con-input">
          <input
            type="text"
            v-model="code"
            name="code"
            class="vs-inputx vs-input--input normal"
            style="border: 1px solid rgba(0, 0, 0, 0.2)" />
        </div>
        <span></span>
      </div>
      <!-- <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Level<sup>*</sup></label>
        <v-select
          @input="(x) => (level = x.value)"
          :clearable="false"
          :value="getSelectValue(level, dataLevel)"
          :reduce="(text) => text.value"
          label="text"
          :options="dataLevel" />
      </div>
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Parent<sup>*</sup></label>
        <v-select
          @input="(x) => (parent = x.value)"
          :clearable="false"
          :value="getSelectValue(parent, parent_array)"
          :reduce="(text) => text.value"
          label="text"
          :options="parent_array" />
      </div> -->
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Is Fuel Consumption<sup>*</sup></label>
        <v-select
          @input="(x) => (is_fuel_consumption = x.value)"
          :clearable="false"
          :value="getSelectValue(is_fuel_consumption, fuel_array)"
          :reduce="(text) => text.value"
          label="text"
          :options="fuel_array" />
      </div>
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Overspeed Threshold (km/h)</label>
        <div class="vs-con-input">
          <input
            type="text"
            v-model="overspeed"
            name="overspeed"
            class="vs-inputx vs-input--input normal"
            style="border: 1px solid rgba(0, 0, 0, 0.2)"
            value="60" />
        </div>
        <span></span>
      </div>
      <div class="flex flex-row items-end" style="gap: 20px">
        <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
          <label class="vs-input--label"
            >Overstay Engine ON Threshold (minutes)</label
          >
          <div class="vs-con-input">
            <input
              type="text"
              v-model="overstay_engine_on"
              name="overstay_engine_on"
              class="vs-inputx vs-input--input normal"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              value="16 menit" />
          </div>
          <span></span>
        </div>
        <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
          <label class="vs-input--label"
            >Overstay Engine OFF Threshold (minutes)</label
          >
          <div class="vs-con-input">
            <input
              type="text"
              v-model="overstay_engine_off"
              name="overstay_engine_off"
              class="vs-inputx vs-input--input normal"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              value="30 menit" />
          </div>
          <span></span>
        </div>
      </div>
      <!-- <div class="flex flex-row items-center" style="gap: 10px">
        <vs-switch v-model="is_mutation"></vs-switch>
        <label class="vs-input--label">Marking Mutation</label>
        <span>
          <vs-tooltip
            color="#4F4F4F"
            text="Jika fitur ini diaktifkan maka setiap kendaraan yang bermutasi ke dalam fleet group akan mendapat notifikasi"
            position="right">
            <feather-icon
              icon="HelpCircleIcon"
              class="cursor-pointer"
              style="width: 15px; height: 50px; color: #616161"></feather-icon>
          </vs-tooltip>
        </span>
      </div> -->
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Phone Numbers<sup>*</sup></label>
        <div class="vs-con-input">
          <div class="flex flex-row w-full" style="gap: 5px">
            <input
              type="text"
              @input="validatePhoneNumber"
              v-model="phone"
              name="phone"
              class="vs-inputx vs-input--input normal"
              style="border: 1px solid rgba(0, 0, 0, 0.2)" />
            <vs-button
              color="primary"
              type="filled"
              @click="pushPhone"
              :disabled="this.phone == '' || this.phoneError !== null"
              >+</vs-button
            >
          </div>
          <p v-if="phoneError" class="text-xs" style="color: red">
            {{ phoneError }}
          </p>
        </div>
        <span></span>
      </div>
      <div class="flex flex-row flex-wrap w-full">
        <div
          class="w-full sm:w-1/3 p-1"
          v-for="(item, index) in phone_array"
          :key="index">
          <div class="flex flex-row rounded-lg text-white font-semibold">
            <vs-button
              class="rounded-r-none p-2 w-full font-semibold"
              color="primary"
              type="border"
              @click="updatePhone(index)"
              >{{ item }}</vs-button
            >
            <vs-button
              class="rounded-l-none p-2"
              color="danger"
              @click="deletePhone(index)"
              >X</vs-button
            >
          </div>
        </div>
      </div>
    </form>
    <vs-divider />
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
          @click="submitForm"
          v-if="!editMode"
          color="primary"
          >Submit
        </vs-button>
        <vs-button
          class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
          @click="updateForm"
          v-if="editMode"
          color="primary"
          >Update
        </vs-button>
        <!--<vs-button color="danger" class="mr-3 mb-2 btn-load-3 vs-con-loading__container" @click="deleteData" v-if="editMode">Delete</vs-button>-->
        <vs-button color="primary" type="border" class="mb-2" @click="closeForm"
          >Cancel</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'

export default {
  props: {
    addNewFleet: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    dataLevel: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  created() {
    this.populateLevel()
    const user = localStorage.getItem('userData')
  },
  watch: {
    name(val) {
      this.name = val.toUpperCase()
    },
    code(val) {
      this.code = val.toUpperCase()
    },
    level(val) {
      if (parseInt(val) > 1) {
        this.calculateLevel(val)
      } else {
        this.parent = ''
        this.parent_array = []
      }
    },
    addNewFleetLocal(va) {
      if (this.addNewFleet && this.editMode) {
        this.name = this.dataEdit.fleet_group_name
        this.code = this.dataEdit.fleet_group_code
        this.is_fuel_consumption = this.dataEdit.is_fuel_consumption
        this.level = this.dataEdit.levels
        this.calculateLevel(this.dataEdit.levels)
        this.parent = this.dataEdit.parent_id
        this.overspeed = this.dataEdit.overspeed
        this.overstay_engine_on = this.dataEdit.overstay_engine_on
        this.overstay_engine_off = this.dataEdit.overstay_engine_off
        this.is_mutation = this.dataEdit.notif_mutation
        this.phone_array = JSON.parse(this.dataEdit.phones)
      }
    },
    editMode(val) {
      if (val) {
        if (this.addNewFleet && this.editMode) {
          this.name = this.dataEdit.fleet_group_name
          this.code = this.dataEdit.fleet_group_code
          this.is_fuel_consumption = this.dataEdit.is_fuel_consumption
          this.level = this.dataEdit.levels
          this.calculateLevel(this.dataEdit.levels)
          this.parent = this.dataEdit.parent_id
          this.overspeed = this.dataEdit.overspeed
          this.overstay_engine_on = this.dataEdit.overstay_engine_on
          this.overstay_engine_off = this.dataEdit.overstay_engine_off
          if (this.dataEdit.phones != null && this.dataEdit.phones != 'null')
            this.phone_array = JSON.parse(this.dataEdit.phones)
          else this.phone_array = []
          //
        }
      } else {
        this.clearFields()
      }
    },
  },
  computed: {
    addNewFleetLocal: {
      get() {
        //
        if (this.addNewFleet && this.editMode) {
          // this.name = this.dataEdit.fleet_group_name;
          // this.code = this.dataEdit.fleet_group_code;
          // this.level = this.dataEdit.levels;
          // this.calculateLevel(this.dataEdit.levels);
          // this.parent = this.dataEdit.parent_id;
        }
        return JSON.parse(this.addNewFleet)
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      level_array: [],
      parent_array: [],
      fuel_array: [
        { text: 'TRUE', value: 1 },
        { text: 'FALSE', value: 0 },
      ],
      phone_array: [],
      phoneError: null,
      phone: '',
      name: '',
      is_fuel_consumption: 1,
      is_mutation: 0,
      code: '',
      status: 1,
      parent: '',
      level: 1,
      overspeed: 0,
      overstay_engine_on: 0,
      overstay_engine_off: 0,
    }
  },
  methods: {
    validatePhoneNumber() {
      const phoneNumberRegex = /^(\+62|62|0)8[1-9]\d{7,10}$/

      if (!phoneNumberRegex.test(this.phone) && this.phone !== '') {
        this.phoneError = 'Invalid phone number format'
      } else {
        this.phoneError = null
      }
    },
    pushPhone() {
      if (this.phone !== '') {
        const spliceNum = this.phone.startsWith('0')
          ? 1
          : this.phone.startsWith('+62')
            ? 3
            : this.phone.startsWith('62')
              ? 2
              : 0
        this.phone = '+62' + this.phone.slice(spliceNum)

        this.phone_array.push(this.phone)
        this.phone = ''
      } else {
        this.$toast.error('Phone Number Cannot Be Empty')
      }
    },
    updatePhone(val) {
      if (this.phone !== '') {
        this.$toast.error('Phone Number Field Should Be Empty Before Updating')
      } else {
        this.phone = this.phone_array[val]
        this.phone_array.splice(val, 1)
        this.validatePhoneNumber()
      }
    },
    deletePhone(val) {
      //
      this.phone_array.splice(val, 1)
      //
    },
    populateLevel() {
      REPO.getListLevel()
        .then((res) => {
          const levels = res.data.data
          let tmp = []
          levels.forEach((x) => {
            tmp.push({
              text: x.description,
              value: x.id,
            })
          })
          this.level_array = tmp
        })
        .catch((err) => {
          //
          this.$toast.error(err.message)
        })
    },
    calculateLevel(val) {
      this.parent_array = []
      this.parent = ''
      this.allData.forEach((x) => {
        if (parseInt(x.levels) === parseInt(val) - 1) {
          this.parent_array.push({
            text: x.fleet_group_name,
            value: x.id,
          })
        }
      })

      if (this.parent_array.length > 0) {
        this.parent = this.parent_array[0].value
      } else {
        this.parent = ''
        this.parent_array = []
      }
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.name = ''
      this.code = ''
      this.level = 1
      this.is_fuel_consumption = 1
      this.parent = ''
      this.overspeed = 0
      this.overstay_engine_on = 0
      this.overstay_engine_off = 0
      this.phone_array = []
      this.phone = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1')
      let dataForm = {
        fleet_group_name: this.name,
        fleet_group_code: this.code,
        levels: this.level,
        is_fuel_consumption: this.is_fuel_consumption,
        overspeed: this.overspeed,
        overstay_engine_on: this.overstay_engine_on,
        overstay_engine_off: this.overstay_engine_off,
        notif_mutation: this.is_mutation,
        phones: JSON.stringify(this.phone_array),
        parent_id: this.parent,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.postFleetGroup(dataForm)
        .then((res) => {
          this.loadingBtnStop('btn-load-1')
          if (res.data.status == 'true') {
            this.clearFields()
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.loadingBtnStop('btn-load-1')
          //
          this.$toast.error(err.message)
        })
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3')
      REPO.deleteFleetGroup(this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-3')
          this.$emit('submitModal', false)
          this.$toast.error('Data Successfully Deleted')
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-3')
          this.$toast.error(err.message)
        })
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2')
      let dataForm = {
        fleet_group_name: this.name,
        is_fuel_consumption: this.is_fuel_consumption,
        fleet_group_code: this.code,
        levels: this.level,
        overspeed: this.overspeed,
        overstay_engine_on: this.overstay_engine_on,
        overstay_engine_off: this.overstay_engine_off,
        notif_mutation: this.is_mutation,
        phones: JSON.stringify(this.phone_array),
        parent_id: this.parent,
        updated_by: this.$dataLocal.UserData().name,
      }
      REPO.updateFleetGroup(dataForm, this.dataEdit.id)
        .then((res) => {
          this.loadingBtnStop('btn-load-2')
          if (res.data.status == 'true') {
            this.clearFields()
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-2')
          this.$toast.error(err.message)
        })
    },
  },
}
</script>

<style>
sup {
  color: red;
}
.vs-tooltip {
  z-index: 999999;
}
</style>
